import { Component, Input, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { CustomerContactModel } from '../../../../../../../app/features/g-route/models/customer-contact.model';
import { CustomerContactsService } from '../../../../../../../app/features/g-route/services/customer-contacts.service';
import { RequestParams } from '../../../../../../common/rest-api/models/request-params';
import { AllStopContacts, IStopContact } from './models/stopContact.model';

@Component({
  selector: 'app-contacts-page',
  templateUrl: 'contacts.page.html',
  styleUrls: [
     './contacts.page.scss',
     '../../../../styles/g-route.styles.scss'
  ]
})
export class ContactsPage implements ViewWillEnter, OnInit {

    currentRoute: string;
    stopName: string;
    loaded:boolean=true;
    contacts: any[] = [];
    otherContacts: IStopContact[] = [];
    requestParams: RequestParams;
    breadcrumbs=[];
    routeStopName: string = "";

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private customerContactsService: CustomerContactsService
    ) { 
        this.currentRoute = null;
    }

    ngOnInit(): void {
        this.loaded=false;
        this.currentRoute = this.router.url;
        this.requestParams = new RequestParams();
        this.requestParams.setPaging(1, 0);
        this.stopName = this.route.snapshot.paramMap.get('id');

        this.routeStopName = localStorage.getItem('routeStopName');
        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
        this.breadcrumbs.push({ label: 'Stop', url: 'route/logsheet/stop/'+ this.stopName });

        window.dispatchEvent(new Event('resize'));
        this.loaded=true;
    }

    ionViewWillEnter(): void {
        this.getContacts();
    }

    async getContacts(): Promise<void> {
        this.loaded=false;
        const contacts = await this.customerContactsService.getContacts(this.stopName, this.requestParams);
        if(contacts!=null){
        this.contacts = (contacts as any).contacts;
        this.otherContacts = (contacts as any).otherContacts
        }
        this.loaded=true;
    }


}